module.exports = __webpack_public_path__ + "static/media/formulas.aa5bf996.JPG";